<template>
  <div>
    <el-dialog
      ref="viewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="abow_dialog"
      width="1200px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogViewForm"
        :model="dialogViewForm"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="省区">
                  <el-input
                    v-model="dialogViewForm.provinceName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="城市">
                  <el-input
                    v-model="dialogViewForm.cityName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="方案名称">
                  <el-input
                    v-model="dialogViewForm.schemeName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="方案编号">
                  <el-input
                    v-model="dialogViewForm.schemeNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="活动日期">
                  <el-input
                    v-model="dialogViewForm.activityDate"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="活动场次">
                  <el-input
                    v-model="dialogViewForm.realFieldTypeValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="执行人">
                  <el-input
                    v-model="dialogViewForm.executorName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="参与者">
                  <el-input
                    v-model="dialogViewForm.partnerNames"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="活动场所">
                  <el-input
                    v-model="dialogViewForm.storeNames"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="修改人">
                  <el-input
                    v-model="dialogViewForm.changeUserName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="修改时间">
                  <el-input
                    v-model="dialogViewForm.changeTime"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="修改类别">
                  <el-input
                    v-model="dialogViewForm.changeTypeValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="修改照片">
                  <div>
                    <show-preview :arr-file-data="picList" />
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 图片预览
import showPreview from '@/components/showPreview'
// 活动派工单API
import { viewActivityReportImageChangeRecordApi } from '@/api/v2/activityReportImageChangeRecord';

export default {
  components: { showPreview },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      dialogViewForm: {},
      baseUrl: process.env.VUE_APP_BASE_API,
      nasUrl: process.env.VUE_APP_NAS_API,
      picList: []
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;
        _this.dialogViewForm = {};
        _this.picList = []
        _this.loadInitData();
      }
    }
  },
  methods: {
    // 加载数据
    loadInitData () {
      let _this = this;
      viewActivityReportImageChangeRecordApi({ id: _this.dataId }).then((response) => {
        const { data } = response;
        _this.dialogViewForm = data;
        let fileUrl = data.changePicUrl;
        let currentYear = new Date().getFullYear()
        let nasYearMonth = (Number(currentYear)-1) + '12'
        if(fileUrl.startsWith('/upload')){
          fileUrl = fileUrl.substring(1)
        }
        let yearMonth = fileUrl.split('/')[2].substring(0,6)
        let url = _this.baseUrl + '/' + fileUrl
        if(Number(nasYearMonth) > Number(yearMonth)){
          url = _this.nasUrl + '/' + fileUrl
        }
        let obj = {}
        obj.name = data.changePicUrl
        obj.url = url
        obj.attachmentName = data.changePicUrl
        obj.attachmentUrl = data.changePicUrl
        _this.picList.push(obj)
      })
    },
    modalClose () {
      this.$emit('update:dialogVisible', false)
    }
  }
}
</script>
<style lang="scss"  scoped>
</style>
